import { render, staticRenderFns } from "./AdminProductsEditScreen.vue?vue&type=template&id=fbb2ce80&scoped=true&"
import script from "./AdminProductsEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductsEditScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb2ce80",
  null
  
)

export default component.exports